<template>
    <div class="swiperwrap" v-finger:swipe="touchswipe">
        <ul class="swiperbg">
            <li v-for="item in infolist" :key="item.id">
                <template v-if="c_options.type=='image'">
                    <img :src="item.img" class="swiperimg" />
                </template>
                <template v-else>
                    <div :class="[c_options.isfull?'editor2':'editor']"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </template>
            </li>
        </ul>
        <transition-group :name="tranname" tag="ul" class="swiperbox">
            <li v-for="(item,index) in infolist" :key="item.id" v-show="index==c_indexcur">
                <template v-if="c_options.type=='image'">
                    <img :src="item.img" class="swiperimg" />
                </template>
                <template v-else>
                    <div :class="[c_options.isfull?'editor2':'editor']"><span v-html="$common.langinfo(item.content,item.content_en)"></span></div>
                </template>
            </li>

        </transition-group>
        <div class="swiperpoint" v-if="c_options.ispoint">
            <a v-for="(item,index) in infolist" :key="item.id" href="#" @click="swipergo(index)" :class="{cs:index==c_indexcur}"></a>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ffswiper',
        data() {
            return {
                lbinterval: null,
                optionsdefault: {
                    'type': 'image', 'isautoplay': true, 'isstop': false, 'duration': 3000, 'ispoint': false, 'isfull': false//isfull是内容格式时是否有padding
                }
            }
        },
        props: {
            infolist: {
                type: Array,
                default: () => []
            },
            options: {
                type: Object,
                default: () => { }
            },
            indexcur: {
                type: Number,
                default: 0
            },
            direct: {
                type: Number,
                default: 1
            }
        },
        computed: {
            c_options: function () {
                return Object.assign({}, this.optionsdefault, this.options);
            },
            itemmax: function () {
                return this.infolist.length;
            },
            c_indexcur: function () {
                let _indexcur = this.indexcur >= this.itemmax ? 0 : this.indexcur < 0 ? this.itemmax - 1 : this.indexcur;
                if (_indexcur != this.indexcur) { this.updateindexcur(_indexcur); }

                return _indexcur;
            },
            tranname: function () {
                return this.direct == 1 ? 'swiperleft' : 'swiperright'
            }
        },
        methods: {
            updateindexcur: function (v, direct) {
                this.$emit('update:indexcur', v);
                if (direct != undefined) {
                    this.$emit('update:direct', direct);
                }
            },
            autoplay: function () {
                if (this.c_options.isautoplay) {
                    this.lbinterval = window.setInterval(() => {
                        if (!this.c_options.isstop) {
                            this.updateindexcur(this.direct == 1 ? this.c_indexcur + 1 : this.c_indexcur - 1);
                        }
                    }, this.c_options.duration);
                }
            },
            touchswipe: function (e) {
                if (e.direction == "Left") {
                    this.updateindexcur(this.c_indexcur + 1, 1);
                }
                else {
                    if (e.direction == "Right") {
                        this.updateindexcur(this.c_indexcur - 1, 2);
                    }
                }
            },
            swipergo: function (v) {
                let direct = v > this.indexcur ? 1 : 2;
                this.updateindexcur(v, direct)
            }
        },

        mounted() {
            this.autoplay();
        },
        beforeDestroy() {
            window.clearInterval(this.lbinterval);
        }
    }
</script>
